import api from './api';

const animalPurchasesService = {
  // Get all animal purchases
  getAllPurchases: async () => {
    const response = await api.get('/api/animal-purchases');
    return response.data;
  },

  // Get animal purchase by ID
  getPurchaseById: async (id) => {
    const response = await api.get(`/api/animal-purchases/${id}`);
    return response.data;
  },

  // Create animal purchase
  createPurchase: async (purchaseData) => {
    const response = await api.post('/api/animal-purchases', purchaseData);
    return response.data;
  },

  // Update animal purchase
  updatePurchase: async (id, purchaseData) => {
    const response = await api.put(`/api/animal-purchases/${id}`, purchaseData);
    return response.data;
  },

  // Delete animal purchase
  deletePurchase: async (id) => {
    const response = await api.delete(`/api/animal-purchases/${id}`);
    return response.data;
  },

  // Get animal purchases statistics
  getStats: async () => {
    const response = await api.get('/api/animal-purchases/stats');
    return response.data;
  },
};

export default animalPurchasesService;